export default __webpack_public_path__ + "bb6e6e156e502ee9066f944dd5579925.jpg";